<template>
  <div>
    <v-app-bar
      app
      fixed
      flat
      height="62"
      class="jdih-header"
      :class="$route.name === '/' || $route.name === 'beranda' ? 'header' : ''"
      :style="{ borderBottom: `1px solid #eee`, zIndex: 3 }">
      <!-- <div class="jdih-header__accent" :style="{ backgroundColor: accentColor }"></div> -->

      <v-container class="jdih-header__inner py-0">
        <div class="jdih-header__row">
          <nuxt-link to="/beranda" class="jdih-brand" @mouseover.native="voiceHover('JDIH Setwan')">
            <v-img
              contain
              width="32"
              height="32"
              alt="JDIH Setwan Kabupaten Klaten"
              :src="require('@/assets/logo/jdihn.png')"
              class="jdih-brand__mark">
              <template v-slot:placeholder>
                <v-row class="fill-height" align="center" justify="center">
                  <v-progress-circular size="18" indeterminate :color="set_color" />
                </v-row>
              </template>
            </v-img>
            <v-img
              contain
              width="90"
              alt="Setwan Kabupaten Klaten"
              :src="require('@/assets/logo/logo-setwan.png')"
              class="jdih-brand__mark jdih-brand__mark--sec">
              <template v-slot:placeholder>
                <v-row class="fill-height" align="center" justify="center">
                  <v-progress-circular size="18" indeterminate :color="set_color" />
                </v-row>
              </template>
            </v-img>
            <div class="jdih-brand__text">
              <div class="jdih-brand__title">JDIH Sekretariat DPRD</div>
              <div class="jdih-brand__sub">Kabupaten Klaten</div>
            </div>
          </nuxt-link>

          <nav class="jdih-nav" aria-label="Menu utama" :style="{ '--accent': accentColor }">
            <template v-for="(item, index) in menu">
              <v-hover
                v-if="item.sub === undefined"
                :key="`link-${index}`"
                v-slot="{ hover }">
                <nuxt-link
                  :to="item.link"
                  class="jdih-nav__link"
                  :class="{ 'is-active': isActive(item.link) }"
                  :style="{
                    '--link-color': (hover || isActive(item.link)) ? accentColor : '#111',
                    fontWeight: (hover || isActive(item.link)) ? 600 : 500
                  }"
                  @mouseover.native="voiceHover(item.title)">
                  {{ item.title }}
                  <span
                    v-if="isActive(item.link)"
                    class="jdih-nav__underline"
                    :style="{ backgroundColor: accentColor }" />
                </nuxt-link>
              </v-hover>

              <v-menu
                v-else-if="item.title === 'Dokumen Hukum'"
                :key="`doc-${index}`"
                v-model="subMenu3"
                offset-y
                :close-on-content-click="true"
                content-class="jdih-mega"
                max-width="980"
                min-width="880">
                <template v-slot:activator="{ on, attrs }">
                  <v-hover v-slot="{ hover }">
                    <button
                      type="button"
                      class="jdih-nav__link jdih-nav__btn"
                      v-bind="attrs"
                      v-on="on"
                      :class="{ 'is-active': isActive(item.link) || subMenu3 }"
                      :style="{
                        '--link-color': (hover || isActive(item.link) || subMenu3) ? accentColor : '#111',
                        fontWeight: (hover || isActive(item.link) || subMenu3) ? 600 : 500
                      }"
                      @mouseover="voiceHover(item.title)">
                      {{ item.title }}
                      <v-icon size="16" class="ml-1" :color="(hover || isActive(item.link) || subMenu3) ? accentColor : '#111'">mdi-chevron-down</v-icon>
                      <span
                        v-if="isActive(item.link)"
                        class="jdih-nav__underline"
                        :style="{ backgroundColor: accentColor }" />
                    </button>
                  </v-hover>
                </template>

                <div class="jdih-mega__panel" :style="{ '--accent': accentColor }">
                  <div class="jdih-mega__head">
                    <div>
                      <div class="jdih-mega__eyebrow">Katalog</div>
                      <div class="jdih-mega__title">Dokumen Hukum</div>
                    </div>
                    <v-hover v-slot="{ hover }">
                      <nuxt-link
                        to="/page"
                        class="jdih-mega__all"
                        :style="{
                          '--link-color': hover ? accentColor : accentColor,
                          fontWeight: hover ? 600 : 500
                        }"
                        @click.native="subMenu3 = false">
                        Lihat semua
                        <v-icon size="14" class="ml-1" :color="hover ? accentColor : '#111'">mdi-arrow-right</v-icon>
                      </nuxt-link>
                    </v-hover>
                  </div>

                  <div class="jdih-mega__grid">
                    <div
                      v-for="(group, m) in item.sub"
                      :key="m"
                      class="jdih-mega__col">
                      <div class="jdih-mega__group">{{ group.title }}</div>
                      <v-hover
                        v-for="(s, k) in (group.sub || [])"
                        :key="k"
                        v-slot="{ hover }">
                        <nuxt-link
                          :to="s.link"
                          class="jdih-mega__item"
                          :class="{ 'is-active': $route.fullPath === s.link }"
                          :style="{
                            '--link-color': (hover || $route.fullPath === s.link) ? accentColor : '#111',
                            fontWeight: (hover || $route.fullPath === s.link) ? 600 : 400
                          }"
                          @mouseover.native="voiceHover(s.title)"
                          @click.native="subMenu3 = false">
                          {{ s.title }}
                        </nuxt-link>
                      </v-hover>
                      <div
                        v-if="!group.sub || group.sub.length < 1"
                        class="jdih-mega__item jdih-mega__empty">
                        -
                      </div>
                    </div>
                  </div>
                </div>
              </v-menu>

              <v-menu
                v-else-if="item.title === 'Tentang Kami'"
                :key="`about-${index}`"
                v-model="subMenu"
                offset-y
                :close-on-content-click="true"
                content-class="jdih-dropdown"
                min-width="240">
                <template v-slot:activator="{ on, attrs }">
                  <v-hover v-slot="{ hover }">
                    <button
                      type="button"
                      class="jdih-nav__link jdih-nav__btn"
                      v-bind="attrs"
                      v-on="on"
                      :class="{ 'is-active': isActive(item.link) || subMenu }"
                      :style="{
                        '--link-color': (hover || isActive(item.link) || subMenu) ? accentColor : '#111',
                        fontWeight: (hover || isActive(item.link) || subMenu) ? 600 : 500
                      }"
                      @mouseover="voiceHover(item.title)">
                      {{ item.title }}
                      <v-icon size="16" class="ml-1" :color="(hover || isActive(item.link) || subMenu) ? accentColor : '#111'">mdi-chevron-down</v-icon>
                      <span
                        v-if="isActive(item.link)"
                        class="jdih-nav__underline"
                        :style="{ backgroundColor: accentColor }" />
                    </button>
                  </v-hover>
                </template>

                <div class="jdih-dropdown__panel" :style="{ '--accent': accentColor }">
                  <v-hover
                    v-for="(i, m) in item.sub"
                    :key="m"
                    v-slot="{ hover }">
                    <nuxt-link
                      :to="i.link"
                      class="jdih-dropdown__item"
                      :class="{ 'is-active': $route.fullPath === i.link }"
                      :style="{
                        '--link-color': (hover || $route.fullPath === i.link) ? accentColor : '#111',
                        fontWeight: (hover || $route.fullPath === i.link) ? 600 : 400,
                        backgroundColor: $route.fullPath === i.link ? set_color_rgb_down : (hover ? '#f5f5f5' : 'transparent')
                      }"
                      @mouseover.native="voiceHover(i.title)"
                      @click.native="subMenu = false">
                      {{ i.title }}
                    </nuxt-link>
                  </v-hover>
                </div>
              </v-menu>

              <v-menu
                v-else
                :key="`info-${index}`"
                v-model="subMenu2"
                offset-y
                :close-on-content-click="true"
                content-class="jdih-dropdown"
                min-width="240">
                <template v-slot:activator="{ on, attrs }">
                  <v-hover v-slot="{ hover }">
                    <button
                      type="button"
                      class="jdih-nav__link jdih-nav__btn"
                      v-bind="attrs"
                      v-on="on"
                      :class="{ 'is-active': isActive(item.link) || subMenu2 }"
                      :style="{
                        '--link-color': (hover || isActive(item.link) || subMenu2) ? accentColor : '#111',
                        fontWeight: (hover || isActive(item.link) || subMenu2) ? 600 : 500
                      }"
                      @mouseover="voiceHover(item.title)">
                      {{ item.title }}
                      <v-icon size="16" class="ml-1" :color="(hover || isActive(item.link) || subMenu2) ? accentColor : '#111'">mdi-chevron-down</v-icon>
                      <span
                        v-if="isActive(item.link)"
                        class="jdih-nav__underline"
                        :style="{ backgroundColor: accentColor }" />
                    </button>
                  </v-hover>
                </template>

                <div class="jdih-dropdown__panel" :style="{ '--accent': accentColor }">
                  <v-hover
                    v-for="(i, m) in item.sub"
                    :key="m"
                    v-slot="{ hover }">
                    <nuxt-link
                      :to="i.link"
                      class="jdih-dropdown__item"
                      :class="{ 'is-active': $route.fullPath === i.link }"
                      :style="{
                        '--link-color': (hover || $route.fullPath === i.link) ? accentColor : '#111',
                        fontWeight: (hover || $route.fullPath === i.link) ? 600 : 400,
                        backgroundColor: $route.fullPath === i.link ? set_color_rgb_down : (hover ? '#f5f5f5' : 'transparent')
                      }"
                      @mouseover.native="voiceHover(i.title)"
                      @click.native="subMenu2 = false">
                      {{ i.title }}
                    </nuxt-link>
                  </v-hover>
                </div>
              </v-menu>
            </template>
          </nav>

          <div class="jdih-actions">
            <v-menu
              transition="slide-y-transition"
              offset-y
              left
              content-class="jdih-dropdown">
              <template v-slot:activator="{ on, attrs }">
                <button
                  type="button"
                  class="jdih-lang"
                  v-bind="attrs"
                  v-on="on"
                  aria-label="Pilih bahasa">
                  <v-icon size="16" class="mr-1">mdi-translate</v-icon>
                  <span>{{ selected.language === 'Indonesia' ? 'ID' : selected.language.slice(0, 2).toUpperCase() }}</span>
                  <v-icon size="14">mdi-chevron-down</v-icon>
                </button>
              </template>

              <v-list dense class="py-1">
                <v-list-item
                  v-for="country in countries"
                  :key="country.title"
                  @click="selected.language = country.title; doTranslation(country.code)"
                  :title="country.title">
                  <v-list-item-content>
                    <div class="d-flex align-center">
                      <v-img
                        :alt="country.altText ? country.altText : `${country.title} flag icon`"
                        :src="
                          country.code !== 'en|id'
                            ? `https://cdn.jsdelivr.net/gh/lewis-kori/vue-google-translate/src/assets/images/flags/__${country.title}.png`
                            : country.flagIconUrl"
                        class="flag"
                        width="20"
                        height="14"
                        contain />
                      <span class="ml-2 body-2">{{ country.title }}</span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
  const Cookie = process.client ? require('js-cookie') : undefined
  export default {
    middleware: 'notAuthenticated',
    data () {
      return {
        clipped: false,
        drawer: true,
        subMenu: false,
        subMenu2: false,
        subMenu3: false,
        dialog: {
          auth: false,
          otp: false,
          info: false
        },
        countries: [
          {
            code: "en|id",
            title: "Indonesia",
            flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/id.svg"
          },
          {
            code: "en|en",
            title: "English",
          },
          {
            code: 'en|af',
            title: 'Afrikaans',
          },
          {
            code: 'en|ar',
            title: 'Arabic',
          },
          {
            code: 'en|ko',
            title: 'Korean',
          },
          {
            code: 'en|lt',
            title: 'Lithuanian',
          }
        ],
        selected: {
          auth: 'login',
          category: '',
          language: 'Indonesia',
          title: 'Indonesia',
        },
        search: '',
        category: [
          {
            name: 'Peraturan Daerah',
            data: "76"
          },
          {
            name: 'Keputusan Bupati',
            data: "30"
          },
          {
            name: 'Rancangan Peraturan Daerah',
            data: "21"
          },
          {
            name: 'Produk Hukum Desa',
            data: "21"
          },
          {
            name: 'Abstrak Peraturan Daerah',
            data: "12"
          },
          {
            name: 'MOU dan PKS',
            data: "5"
          },
          {
            name: 'Surat Edaran Bupati',
            data: "9"
          },
          {
            name: 'Propemperda',
            data: "2"
          },

          {
            name: 'Peraturan Bupati',
            data: "15"
          },
          {
            name: 'Instruksi Bupati',
            data: "20"
          },
          {
            name: 'Rancangan Peraturan Bupati',
            data: "33"
          },
          {
            name: 'Naskah Akademis',
            data: "21"
          },
          {
            name: 'Staatsblad',
            data: "5"
          },
          {
            name: 'Surat Edaran Sekda',
            data: "2"
          },
          {
            name: 'Peraturan Terjemahan Resmi',
            data: "76"
          },
        ],
        produkHukum: [
          {
            name: 'Peraturan Daerah',
            data: "76"
          },
          {
            name: 'Keputusan Bupati',
            data: "30"
          },
          {
            name: 'Rancangan Peraturan Daerah',
            data: "21"
          },
          {
            name: 'Abstrak Peraturan Daerah',
            data: "12"
          },

          {
            name: 'Peraturan Bupati',
            data: "15"
          },
          {
            name: 'Instruksi Bupati',
            data: "20"
          },
          {
            name: 'Rancangan Peraturan Bupati',
            data: "33"
          },
          {
            name: 'Produk Hukum Desa',
            data: "12"
          },
          {
            name: 'Staatsblad',
            data: "5"
          },
          {
            name: 'Peraturan Terjemahan Resmi',
            data: "76"
          },
        ],
        menu: [
          {
            title: 'Beranda',
            link: '/beranda'
          },
          {
            title: 'Tentang Kami',
            link: '/visi-misi',
            sub: [
              {
                title: 'Dasar Hukum',
                link: '/dasar-hukum'
              },
              {
                title: 'Visi dan Misi',
                link: '/visi-misi'
              },
              {
                title: 'Tugas Pokok, Fungsi dan Program Kerja',
                link: '/tugas-pokok-fungsi-dan-program-kerja'
              },
              {
                title: 'Hubungi Kami',
                link: '/hubungi-kami'
              },
              {
                title: 'Anggota JDIH',
                link: '/anggota-jdih'
              },
              {
                title: 'SOP',
                link: '/SOP'
              },
              {
                title: 'Tim Pengelola',
                link: '/struktur-organisasi'
              }
            ]
          },
          {
            title: 'Dokumen Hukum',
            link: '/page',
            sub: []
          },
          {
            title: 'Informasi',
            link: '/berita',
            sub: [
              {
                title: 'Propemperda',
                link: '/propemperda'
              },
              {
                title: 'Berita',
                link: '/berita'
              },
              {
                title: 'Pengumuman',
                link: '/pengumuman'
              },
              {
                title: 'Video',
                link: '/video'
              },
              {
                title: 'Galeri',
                link: '/galeri'
              },
              {
                title: 'Statistik',
                link: '/statistik'
              }
            ]
          },
          {
            title: 'Pengaduan',
            link: '/pengaduan'
          },
        ]
      }
    },
    head () {
  return {
    script: [
      {
        src: '/bundle.js',
        type: 'text/javascript',
        defer: true,
        body: true
      },
    ]
  }
},
    watch: {
      '$route': function() {
        if (this.$route.path.split('/')[1] !== 'page') {
          this.search = ''
          this.selected.category = ''
        }
      },
      '$route.query.jenis': function(val) {
        for(let i = 0; i < this.category.length; i++){
          if (this.category[i].slug === val) {
            this.selected.category = this.category[i].slug
          } else {
            // status = false
          }
        }
      },
      '$route.query.search': function(val) {
        this.search = val
      },
    },
    components: {

    },

    computed: {
      hasClickListener() {
        return Object.keys(this.$listeners).includes('on-country-click');
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.member.auth.user
      },
      token () {
        return this.$store.state.member.auth.token
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      accentColor () {
        const color = this.set_color || '#111111'
        if (typeof color === 'string' && /^#[0-9A-Fa-f]{8}$/.test(color)) {
          return color.slice(0, 7)
        }
        return color
      },
      set_color_rgb () {
        let [r, g, b] = this.accentColor.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.accentColor.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.accentColor.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      company () {
        return this.$store.state.header.config
      },
    },
    mounted () {
      if (!process.server) {
        const script = document.createElement("script");
        script.onload = this.onScriptLoaded;
        script.type = "text/javascript";
        script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        document.head.appendChild(script);
      }
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) {
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        }
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })

      storeScroll()

      this.fetchCategory()

      if(this.$route.query.search !== undefined){
        this.search = this.$route.query.search
      } else {
        this.search = ''
      }

      if(this.$route.path.split('/')[1] !== 'page'){
        this.selected.category = this.category[0].slug
      }
    },
    beforeCreate() {

    },
    created() {

    },
    methods: {
      isActive (link) {
        const current = this.$route.path === '/' ? 'beranda' : this.$route.path.split('/')[1]
        const target = link.split('/')[1]
        return current === target
      },
      googleTranslateElementInit() {
            new google.translate.TranslateElement(
              { pageLanguage: 'id', autoDisplay: false },
              'app'
            );

      },
      doTranslation (code) {
        this.googleTranslateElementInit()
        this.selected.title = ''

        this.selected.title = this.countries.find(country => country.code === code).title

        setTimeout(() => {
          if (typeof window !== 'undefined') {

            window.doGTranslate(code)

            if (this.hasClickListener) {
              this.$emit('on-country-click')
            }
          }
        }, 1000)
      },
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetchCategory () {
        let params = {
          limit: 1000000,
          'title[nin]': 'Surat Keputusan,Surat Keputusan DPRD'
        }

        await this.$axios.$get(`${process.env.API}sites/doc/doc_type`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.category = [
              {
                name: "Semua Dokumen",
                slug: "semua-dokumen",
              }
            ]
            let category = []
            category = res.results.data.map(item => {
              const container = {};

              container.title = item.title;
              container.id = item.id;
              container.par_id = item.par_id;
              container.singkatan = item.singkatan
              container.link = `/page?jenis=${(item.title.split(' ').join('-')).toLowerCase()}`;
              return container
            })
            this.menu[2].sub = this.changeData(category)

            let selecCategory = []
            selecCategory = res.results.data.map(item => {
              const container = {};
              container.par_id = item.par_id;
              container.name = item.title;
              container.slug = (item.title.split(' ').join('-')).toLowerCase();
              return container
            })

            for (let i in selecCategory) {
              if(selecCategory[i].par_id !== '0') {
                this.category.push(
                  {
                    name: selecCategory[i].name,
                    slug: selecCategory[i].slug
                  }
                )
              }

            }




            for(let i = 0; i < this.category.length; i++){
              if (this.category[i].slug === this.$route.query.jenis) {
                this.selected.category = this.category[i].slug
              } else {
                // status = false
              }
            }
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.sub = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },
      changeQuery() {
        this.$router.replace({'path': '/page', 'query': {'jenis': this.selected.category === '' ? 'semua-dokumen' : this.selected.category, 'search': this.search === null ? '' : this.search , 'category': this.$route.query.category === undefined ? '' : this.$route.query.category, 'tahun': this.$route.query.tahun === undefined ? '' : this.$route.query.tahun, 'nomor': this.$route.query.nomor === undefined ? '' : this.$route.query.nomor, 'title': this.$route.query.title === undefined ? '' : this.$route.query.title}})
      },
      toFilterCategory() {
        this.$router.replace({'path': '/page', 'query': {'jenis': this.selected.category === '' ? 'semua-dokumen' : this.selected.category, 'search': this.search === null ? '' : this.search , 'category': this.$route.query.category === undefined ? '' : this.$route.query.category, 'tahun': this.$route.query.tahun === undefined ? '' : this.$route.query.tahun, 'nomor': this.$route.query.nomor === undefined ? '' : this.$route.query.nomor, 'title': this.$route.query.title === undefined ? '' : this.$route.query.title}})
      },
      toList(link) {
        this.$router.push(`${link}`)
      },
      goTo (item) {
        if (item.type === 'logout') {
          Cookie.remove('token')
          Cookie.remove('user')
          Cookie.remove('fcm')
          Cookie.remove('notif')

          window.location = '/admin/auth/login'
        } else {
          this.$router.push('/admin/profil')
        }
      },
      goBack () {
        if (this.$route.name === 'reservasi-slug') {
          this.$router.push('/reservasi')
        } else if (this.$route.name === 'berita-slug') {
          this.$router.push('/berita')
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
</script>

<style>
  .jdih-header.v-app-bar {
    background: #fff !important;
    box-shadow: none !important;
  }

  .jdih-header .v-toolbar__content {
    padding: 0 !important;
    height: 62px !important;
  }

  .jdih-header__accent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
  }

  .jdih-header__inner {
    max-width: 1200px;
    height: 100%;
  }

  .jdih-header__row {
    display: flex;
    align-items: center;
    height: 62px;
    gap: 20px;
  }

  .jdih-brand {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none !important;
    color: inherit !important;
    flex-shrink: 0;
    min-width: 0;
  }

  .v-application a.jdih-brand {
    color: inherit !important;
    text-decoration: none !important;
  }

  .jdih-brand__mark {
    flex-shrink: 0;
  }

  .jdih-brand__mark--sec {
    margin-left: -2px;
  }

  .jdih-brand__text {
    line-height: 1.15;
    margin-left: 4px;
  }

  .jdih-brand__title {
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
    letter-spacing: -0.01em;
  }

  .jdih-brand__sub {
    font-size: 11px;
    color: #6b6b6b;
    font-weight: 500;
    margin-top: 1px;
  }

  .jdih-nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    gap: 2px;
    min-width: 0;
  }

  .jdih-nav__link,
  .jdih-nav__btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 40px;
    padding: 0 10px;
    border: 0;
    background: transparent;
    color: var(--link-color, #111) !important;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none !important;
    text-transform: none;
    letter-spacing: 0;
    cursor: pointer;
    white-space: nowrap;
    border-radius: 4px;
    transition: color 0.15s ease, background-color 0.15s ease;
  }

  .v-application a.jdih-nav__link {
    color: var(--link-color, #111) !important;
    text-decoration: none !important;
  }

  .jdih-nav__link:hover,
  .jdih-nav__btn:hover {
    background: #f3f3f3;
  }

  .jdih-nav__link.is-active,
  .jdih-nav__btn.is-active {
    font-weight: 600;
  }

  .jdih-nav__underline {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 4px;
    height: 2px;
    border-radius: 1px;
  }

  .jdih-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding-left: 8px;
    border-left: 1px solid #e8e8e8;
    margin-left: 4px;
  }

  .jdih-lang {
    display: inline-flex;
    align-items: center;
    height: 34px;
    padding: 0 10px;
    border: 1px solid #e2e2e2;
    background: #fafafa;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #444;
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }

  .jdih-lang:hover {
    background: #fff;
    border-color: #cfcfcf;
  }

  .jdih-mega {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #ececec;
    border-radius: 8px !important;
    overflow: hidden;
    margin-top: 6px !important;
  }

  .jdih-mega__panel {
    background: #fff;
    padding: 14px 16px 16px;
  }

  .jdih-mega__head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
  }

  .jdih-mega__eyebrow {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 2px;
    color: #111;
  }

  .jdih-mega__title {
    font-size: 14px;
    font-weight: 700;
    color: #111;
  }

  .jdih-mega__all {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    text-decoration: none !important;
    color: var(--link-color, #111) !important;
    transition: color 0.15s ease;
  }

  .jdih-mega__grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px 16px;
  }

  .jdih-mega__group {
    font-size: 11px;
    font-weight: 700;
    color: #111;
    margin-bottom: 6px;
    padding-bottom: 5px;
    border-bottom: 1px solid #f0f0f0;
  }

  .jdih-mega a.jdih-mega__item,
  .v-application .jdih-mega a.jdih-mega__item,
  .jdih-mega__item {
    display: block;
    padding: 4px 0;
    font-size: 12px;
    color: var(--link-color, #111) !important;
    text-decoration: none !important;
    line-height: 1.35;
    transition: color 0.15s ease;
  }

  .jdih-mega__empty {
    color: #999 !important;
    cursor: default;
  }

  .jdih-dropdown {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #ececec;
    border-radius: 8px !important;
    overflow: hidden;
    margin-top: 6px !important;
  }

  .jdih-dropdown__panel {
    background: #fff;
    padding: 6px;
    min-width: 240px;
  }

  .jdih-dropdown a.jdih-dropdown__item,
  .v-application .jdih-dropdown a.jdih-dropdown__item,
  .jdih-dropdown__item {
    display: block;
    padding: 10px 12px;
    border-radius: 4px;
    font-size: 13px;
    color: var(--link-color, #111) !important;
    text-decoration: none !important;
    line-height: 1.35;
    transition: background-color 0.15s ease, color 0.15s ease;
  }

  .jdih-dropdown__item:hover {
    background: #f5f5f5;
  }

  .jdih-dropdown__item.is-active {
    font-weight: 600;
  }

  .header {
  }

  .header-default {
    background-color: #a20000 !important;
  }

  .header-detail {
    background-color: transparent !important;
  }

  html:not([data-scroll="0"]) .header {
    background-repeat: no-repeat;
    background-position: 100%;
    background-size: cover;
  }

  .header .menu {
    background-color: transparent !important;
  }

  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: #ffffff !important;
    box-shadow: none !important;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    margin-bottom: 0px !important;
  }

  .theme--light.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {
    background: #ffffff !important;
    border-width: 0.25px !important;
    border-radius: 6px;
    margin-bottom: 0px !important;
  }

  .error_input_border.v-input--is-focused > .v-input__control > .v-input__slot {
    background: #ffffff !important;
    border: 0.25px solid red !important;
    border-radius: 6px;
    margin-bottom: 0px !important;
  }

  .input-border-right-none.v-input--is-focused > .v-input__control > .v-input__slot {
    border-radius: 6px 0px 0px 6px !important;
  }

  .border-input-none.v-input--is-focused > .v-input__control > .v-input__slot {
    border-width: none !important;
  }

  .border-input-none > .v-input__control > .v-input__slot {
    border: none !important;
  }

  .border-input-none > .v-input__control > .v-input__slot > .v-input__prepend-inner {
    opacity: 0.6;
  }

  .border-input-none > .v-input__control > .v-input__slot > .v-text-field__slot {
    opacity: 0.6;
  }

  .input-border-right-none > .v-input__control > .v-input__slot {
    border-radius: 6px 0px 0px 6px !important;
  }

  .v-text-field--outlined > .v-input__control > .v-input__slot {
    background: #FFFFFF !important;
    box-shadow: none !important;
    border-radius: 6px !important;
    margin-bottom: 0px !important;
  }

  @media (max-width: 1260px) {
    .jdih-brand__text {
      display: none;
    }

    .jdih-nav__link,
    .jdih-nav__btn {
      padding: 0 8px;
      font-size: 12px;
    }

    .jdih-mega__grid {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 10px 12px;
    }
  }
</style>
